import { useCallback, useState } from 'react';

import { clampPage, getPageItems } from '../utils/pagination';

/** Client-side pagination for a list (zero-based page, exposed range is one-based). */
export const useListPagination = <T,>(items: T[], pageSize: number) => {
  const [page, setPage] = useState(0);
  const pageCount = Math.ceil(items.length / pageSize);
  const currentPage = clampPage(page, pageCount);

  const reset = useCallback(() => setPage(0), []);

  return {
    page: currentPage,
    pageSize,
    total: items.length,
    items: getPageItems(items, currentPage, pageSize),
    from: currentPage * pageSize + 1,
    to: Math.min((currentPage + 1) * pageSize, items.length),
    setPage,
    reset,
  };
};

export type ListPagination<T> = ReturnType<typeof useListPagination<T>>;
